import {Checkbox, RadioGroup, RadioGroupItem} from "../components";
import React, {Dispatch, SetStateAction, useState} from "react";
import {useIngredients} from "../hooks/useIngredients";
import {cn} from "../lib/utils";
import {useTranslation} from "react-i18next";

const Ingredients = ({
                       people,
                       setPeople,
                       productId,
                       ingredientHandles,
                     }: {
  people: 2 | 4;
  setPeople: Dispatch<SetStateAction<2 | 4>>;
  productId: number;
  ingredientHandles: string[];
}): React.ReactElement => {
  const {t} = useTranslation();
  const {ingredients} = useIngredients({
    productId: productId,
    ingredientHandles: ingredientHandles,
    people,
  });

  const [checkedIngredients, setCheckedIngredients] = useState<string[]>([]);

  if (ingredients.length === 0) return null;

  return (
    <div className="flex flex-col md:p-6 bg-white rounded-3xl gap-4">
      <div className="w-full flex justify-between max-md:px-4">
        <h2>{t("recipe_details.ingredients.general")}</h2>
        <div className="flex gap-2 items-center -mr-1">
          <small className="opacity-75">{t("recipe_details.ingredients.portions")}</small>
          <RadioGroup
            small
            defaultValue="2"
            className="w-20 h-full"
            onValueChange={(v) => {
              const nr = parseInt(v);
              nr === 4 ? setPeople(4) : setPeople(2);
            }}
          >
            <RadioGroupItem value="2" />
            <RadioGroupItem value="4" />
          </RadioGroup>
        </div>
      </div>
      <div className="flex flex-col max-md:px-3 max-md:pr-0">
        {ingredients.map(({title, amount, imageUrl}) => {
          const isChecked = checkedIngredients.includes(title);
          return (
            <label
              key={title}
              htmlFor={title}
              className="flex gap-3 md:gap-4 group [&>div]:last:border-none"
            >
              <img
                className={cn(
                  "w-14 h-14 rounded-2xl",
                  isChecked && "opacity-50",
                )}
                src={imageUrl}
                alt={`Pilt ${title}`}
                loading="lazy"
              />
              <div
                className="flex flex-row items-center flex-1 h-[58px] mb-[2px] pb-[4px] border-zinc-700/20 border-b-[0.5px] relative max-md:pr-4">
                <div
                  className={cn(
                    "flex flex-col flex-1",
                    isChecked && "opacity-50",
                  )}
                >
                  <span className="font-semibold text-zinc-600 group-hover:text-black leading-5">
                    {title}
                  </span>
                  {amount && <small className="text-slate-500">{amount}</small>}
                </div>
                <Checkbox
                  id={title}
                  checked={isChecked}
                  onCheckedChange={(checked) => {
                    if (checked) {
                      setCheckedIngredients([...checkedIngredients, title]);
                    } else {
                      setCheckedIngredients(
                        checkedIngredients.filter((i) => i !== title),
                      );
                    }
                  }}
                />
              </div>
            </label>
          );
        })}
      </div>
    </div>
  );
};

export {Ingredients};
